import React from "react";
import Tooltip from "../../connectui/component/display/Tooltip";
import Text from "../../connectui/component/display/Text";
import ButtonText from "../../connectui/component/input/button/ButtonText";

const TooltipExample = () => {
  return (
    <div>
      <h3>Tooltip Component Example</h3>

      <Tooltip
        tooltipContent={
          <>
            <Text>Tooltip content</Text>
          </>
        }
      >
        <ButtonText>Hover over me</ButtonText>
      </Tooltip>
    </div>
  );
};

export default TooltipExample;
